(function () {
  function handleClick(e) {
    var button = e.target.closest('.buy-now-btn');
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (response) { return response.json(); })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove('loading');
    });
  }

  document.addEventListener('click', handleClick);
})();
